import {useState, useContext} from 'react';
import {AxiosContext} from '../components/utils/AxiosProvider';
// import useAxios, { configure } from "axios-hooks";

const endpoint = '/api/1/user/uploads';

export const usePostDocument = state => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [response, setResponse] = useState(state);
    const {client: axiosClient} = useContext(AxiosContext);

    const onDocumentPosted = result => {
        setIsLoading(false);
        setError(null);
        setResponse(result.data);
    };

    const postNewManualDocument = docForm => {
        if (!docForm) {
            throw new Error('No files');
        }
        return axiosClient.post(endpoint, docForm);
    };

    const postNewDocument = docForm => {
        setIsLoading(true);
        axiosClient
            .post(endpoint, docForm)
            .then(onDocumentPosted)
            .catch(onError);
    };

    const onError = error => {
        setError(error);
        setIsLoading(false);
    };

    return {
        postNewDocument,
        isLoading,
        error,
        response,
        postNewManualDocument,
    };
};

export default usePostDocument;
